import { Button, Form, Input, message, Modal, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import { apiCall } from "../utils/Api";
import { useSession } from "../utils/Session";
import { DeleteFilled } from '@ant-design/icons';

export default function CompanyCategories(props) {
   
    const [session, setSession] = useSession();

    const [cats, setCats] = useState(session?.contact.categories || []);
    const [results, setResults] = useState([]);


    useEffect(() => {

        if(!props?.form){ return; }

        props.form.setFieldsValue({"categories" : JSON.stringify(cats)})
    }, [cats])

    const validCategories = () => {
        apiCall("account/getValidCategories", {}, (_s, _r) => {
            if (_s) {
                setResults(_r);
            } else {
                message.error(_r.error);
            }
        });
    };

    useEffect(validCategories, []);

    const addCategory = () => {
        if (cats.length >= 3) return;
        const defaultCategory = results[0]?.category || "";
        const defaultSpecialty = results[0]?.specialties?.[0] || "";
        setCats([
            ...cats,
            {
                category: defaultCategory,
                specialty: defaultSpecialty
            }
        ]);
    };

    const updateCat = (index, field, value) => {
        const updated = [...cats];
        updated[index][field] = value;

        // If category is changing, update specialty to first available
        if (field === "category") {
            const match = results.find(r => r.category === value);
            updated[index].specialty = match?.specialties?.[0] || "";
        }

        setCats(updated);
    };

    const removeCat = (index) => {
        const updated = [...cats];
        updated.splice(index, 1);
        if(updated.length === 0){
            Modal.confirm({
                title : "Warning",
                content : <>Removing all categories will delete the company from the business directory. <div className="shim" />Are you sure you want to proceed?</>,
                onOk : () => {
                      setCats(updated);
                }
            })
        } else {
              setCats(updated);
        }

      
    };

    const CatSelect = ({ data, index }) => {
        const { category = "", specialty = "" } = data;

        const specialties = results.find(r => r.category === category)?.specialties || [];

        return (
            <div>
                <Space size={2}>
                    <Form.Item label="Category">
                        <Select
                            style={{ width: "160px" }}
                            value={category}
                            onChange={(val) => updateCat(index, "category", val)}
                        >
                            {results.sort((a, b) => a.category.localeCompare(b.category)).map(item => (
                                <Select.Option key={item.category} value={item.category}>
                                    {item.category}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Specialty">
                        <Select
                            style={{ width: "160px" }}
                            value={specialty}
                            onChange={(val) => updateCat(index, "specialty", val)}
                            disabled={specialties.length === 0}
                        >
                            {specialties.sort((a, b) => a.localeCompare(b)).map(item => (
                                <Select.Option key={item} value={item}>
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Button style={{"marginTop" : "5px"}} icon={<DeleteFilled />} danger type="primary" onClick={() => removeCat(index)} />
                </Space>
            </div>
        );
    };

    return (
        <>
            <Form.Item hidden name="categories">
                <Input />
            </Form.Item>
            {cats.map((item, idx) => (
                <CatSelect key={idx} data={item} index={idx} />
            ))}
            <Button type="primary" disabled={cats.length >= 3} onClick={addCategory}>
                Add specialty
            </Button>
            <div className="shim" /><div className="shim" />
        </>
    );
}
